import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const Rate = ({ rate }) => {
	return (
		<React.Fragment>
			This change will result in a<b>{` ${rate.differenceInRate} ${rate.differenceInRate.includes('(') ? 'DECREASE' : 'INCREASE'} IN PREMIUM `}</b>effective date ({moment(rate.transactionDate).format('L')}) to the end of the period ({moment(rate.policyExpirationDate).format('L')}).
		</React.Fragment>
	);
};

Rate.propTypes = {
	rate: PropTypes.any.isRequired,
};

export default Rate;
